import { useCallback, useState } from "react";

import { translate } from "app/filters/i18nFilter";
import { InputSettingSection } from "app/pages/digital-marketing/generative-ai/llm-tracker/menu/items/edit/InputSettingSection";
import type { ICampaignSettingField } from "app/pages/digital-marketing/generative-ai/llm-tracker/menu/types";

interface ICampaignNameSettingProps extends ICampaignSettingField {
    newCampaignName: string;
    setNewCampaignName: (name: string) => void;
}

export const CampaignNameSetting = ({ newCampaignName, setNewCampaignName, isReadOnly }: ICampaignNameSettingProps) => {
    const [error, setError] = useState<string>("");

    const onNameChange = useCallback(
        (name: string): void => {
            const trimmedValue = name.trim();
            setNewCampaignName(trimmedValue);
            setError(!trimmedValue ? translate("llmTracker.campaignQuery.edit.name.error.empty") : "");
        },
        [setNewCampaignName, setError],
    );

    return (
        <InputSettingSection
            title={translate(
                isReadOnly
                    ? "llmTracker.campaignQuery.edit.name.title.read-only"
                    : "llmTracker.campaignQuery.edit.name.title",
            )}
            fieldPlaceholder={translate("llmTracker.campaignQuery.edit.name.placeholder")}
            isDisabled={isReadOnly}
            defaultValue={newCampaignName}
            onValueChange={onNameChange}
            error={error}
            autoFocus
        />
    );
};
